<template>
  <Modal v-model="buttonLayoutConfigurationModal" :title="$t('key1002310')" :width="1000"
    :transfer="false" class-name="buttonLayoutConfigurationStyle">
    <!--按钮配置-->
    <Card :bordered="false" dis-hover class="mb20">
      <template #title>
        <h2 class="title_box">{{ $t('key1002312') }}</h2>
      </template>
      <div class="table_box">
        <Table
          ref="tableDom"
          highlight-row
          border
          max-height="550"
          :draggable="draggable"
          :loading="tableLoading"
          :columns="tableColumns"
          :data="tableData"
          @on-drag-drop="dragDrop">
        </Table>
      </div>
    </Card>
    <!--布局预览-->
    <Card :bordered="false" dis-hover>
      <template #title>
        <h2 class="title_box">{{ $t('key1002313') }}</h2>
      </template>
      <div class="mallDetailsPageSettings_img_box">
        <img :src="mallDetailsPageSettings_img" alt="" width="926" height="357">
        <div class="options_box" v-if="optionsList.length >0">
          <template v-for="item in optionsList">
            <template v-if="item.imgIcon">
              <Button class="subscribe-btn" type="primary" :ghost="item.mainButtonValue === 0">
                <div class="flex align-items-center">
                  <img :src="skilledHand_logo" width="32" height="32" alt="">
                  <span class="ml5">{{ item.buttonName }}</span>
                </div>
              </Button>
            </template>
            <Button v-else class="subscribe-btn" type="primary" :ghost="item.mainButtonValue === 0">
              {{ item.buttonName }}
              <Tooltip transfer v-if="item.iconText" placement="top" max-width="600" :content="$t('key1002311')">
                <Icon class="cursor" size="18" type="md-help-circle"></Icon>
              </Tooltip>
            </Button>
          </template>
          <template v-if="moreOptionsList.length >0">
            <Dropdown transfer>
              <Button class="more-subscribe-btn" type="primary" ghost>
                <span>{{ $t('key1000106') }}</span>
                <Icon type="ios-arrow-down"></Icon>
              </Button>
              <DropdownMenu slot="list">
                <DropdownItem v-for="item in moreOptionsList">{{ item.buttonName }}</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </template>
        </div>

      </div>
    </Card>
    <template #footer>
      <Button class="mr15" @click="buttonLayoutConfigurationModal = false">{{ $t('key1000112') }}</Button>
      <Button class="mr15" type="primary" @click="buttonLayoutConfigurationBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {BUTTONLAYOUTCONFIGURATION} from "@/utils/enum";
import {commonLocalStorage, getConfigurationItemData, saveErpCommonSettingParam} from "@/utils/common";

export default {
  name: 'buttonLayoutConfigurationModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      buttonLayoutConfigurationModal: false,
      tableColumns: [
        {
          title: '',
          key: 'sort',
          align: 'center',
          width: 70,
          renderHeader: (h) => {
            return h('span', '')
          },
          render: (h) => {
            return h('div', {
              class: 'cursor-move',
              on: {
                mousedown() {
                  v.draggable = true;
                }
              }
            }, [
              h('Icon', {
                props: {
                  type: 'md-move',
                  size: 18
                },
                class: 'cursor-move'
              })
            ])
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002306'),
          key: 'buttonName',
          align: 'center',
          minWidth: 200,
          render(h, params) {
            let text = params.row.buttonName;
            if (v.moreOptionsList.length > 0) {
              v.moreOptionsList.map((item) => {
                if (item.buttonName === params.row.buttonName) {
                  text += aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002307');
                }
              });
            }
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002308'),
          key: 'mainButton',
          align: 'center',
          minWidth: 300,
          render(h, params) {
            let mainButtonValue = params.row.mainButtonValue;
            let disabledValue = false;
            if (v.moreOptionsList.length > 0) {
              v.moreOptionsList.map((item) => {
                if (item.buttonName === params.row.buttonName) {
                  disabledValue = true;
                }
              });
            }
            return h('i-switch', {
              props: {
                value: mainButtonValue,
                trueValue: 1,
                falseValue: 0,
                disabled: disabledValue
              },
              on: {
                'on-change': (val) => {
                  v.$set(v.tableData[params.index], 'mainButtonValue', val);
                  v.updateSetData(v.tableData);
                }
              }
            }, [h('span', {
              slot: "open",
              domProps: {
                innerHTML: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000392')
              }
            }),
              h('span', {
                slot: "close",
                domProps: {
                  innerHTML: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000393')
                }
              })
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002309'),
          key: 'isItVisible',
          align: 'center',
          minWidth: 200,
          render(h, params) {
            let isItVisible = params.row.isItVisible;
            return h('i-switch', {
              props: {
                value: isItVisible,
                trueValue: 1,
                falseValue: 0
              },
              on: {
                'on-change': (val) => {
                  v.$set(v.tableData[params.index], 'isItVisible', val);
                  v.updateSetData(v.tableData);
                }
              }
            }, [h('span', {
              slot: "open",
              domProps: {
                innerHTML: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000392')
              }
            }),
              h('span', {
                slot: "close",
                domProps: {
                  innerHTML: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000393')
                }
              })
            ]);
          }
        },
      ],
      tableData: BUTTONLAYOUTCONFIGURATION,
      draggable: false,
      paramKey: 'mallDetailsPageSettings',
      mallDetailsPageSettings_img: require('@/assets/images/mallDetailsPageSettings.png'),
      skilledHand_logo: require('@/assets/images/skilledHand_logo.png'),
      optionsList: [],
      moreOptionsList: [],
    }
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
  },
  methods: {
    // 初始化数据
    initButtonLayoutConfigurationData() {
      this.tableData = [];
      const info = commonLocalStorage.getItem('configurationItemInfo') ?? this.$store.state.configurationItemInfo;
      let mallDetailsPageSettings = info?.mallDetailsPageSettings || [];
      mallDetailsPageSettings.map((ele) => {
        BUTTONLAYOUTCONFIGURATION.map((talg) => {
          if (ele.paramKey === talg.paramKey) {
            ele.buttonName = talg.buttonName;
          }
        })
      });
      this.tableData = JSON.parse(JSON.stringify(mallDetailsPageSettings));
      this.updateSetData(mallDetailsPageSettings);
      this.buttonLayoutConfigurationModal = true;
      this.$forceUpdate();
    },
    // 拖拽排序
    dragDrop(oldIndex, newIndex) {
      this.tableData[oldIndex] = this.tableData.splice(newIndex, 1, this.tableData[oldIndex])[0];
      this.tableData.map((item, index) => {
        item.sortNo = index + 1;
      });
      this.draggable = false;
      this.updateSetData(this.tableData);
      this.$forceUpdate();
    },
    // 按钮布局配置--确定按钮
    buttonLayoutConfigurationBtn() {
      let paramValueList = JSON.stringify(this.tableData);
      let queryList = [
        {
          businessId: this.userInfo.merchantId,
          paramKey: this.paramKey,
          paramValue: paramValueList,
        }
      ];
      saveErpCommonSettingParam(queryList).then(() => {
        this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000708'));
        this.buttonLayoutConfigurationModal = false;
        getConfigurationItemData();
        this.$emit('updateConfigData', true);
      });
    },
    // 实时更新设置项
    updateSetData(newData) {
      let v = this;
      let data = JSON.parse(JSON.stringify(newData));
      setTimeout(() => {
        let newList = data.filter((item) => {
          return item.isItVisible === 1
        });
        if (newList.length > 0) {
          let length = newList.length > 4 ? 3 : 4;
          v.optionsList = newList.slice(0, length);
          v.moreOptionsList = newList.slice(length);
        } else {
          v.optionsList = [];
          v.moreOptionsList = [];
        }
        v.$forceUpdate();
      }, 400);
    }
  },
  watch: {},
  components: {}
};
</script>

<style lang="less" scoped>
.buttonLayoutConfigurationStyle /deep/ {
  .ivu-card-head {
    padding: 0 0 10px 0;
  }

  .title_box {
    color: #333;
    font-size: 14px;
    font-weight: bold;
  }

  .mallDetailsPageSettings_img_box {
    position: relative;
    display: flex;
    justify-content: center;

    .options_box {
      position: absolute;
      left: 357px;
      bottom: 18px;

      .subscribe-btn, .more-subscribe-btn {
        min-width: 120px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 15px;
        font-family: PingFang SC;
        font-weight: 400;
        cursor: pointer;
        margin-right: 10px;
        border-radius: 1px;
      }

      .more-subscribe-btn {
        min-width: 80px;
      }

      .ivu-btn-primary {
        color: #fff;
        background-color: #FD5425;
        border-color: #FD5425;
      }

      .ivu-btn-primary:hover {
        color: #fff;
        background-color: #FD5425;
        border-color: #FD5425;
      }

      .ivu-btn-ghost.ivu-btn-primary {
        color: #FD5425;
        background: 0 0;
      }
    }
  }
}
</style>
